import { TextField, Typography } from "@mui/material";

import { FormGroup, FormLabel } from "react-bootstrap";
import ReactSelect from "react-select";
import CountrySelector from "./CountrySelector";
import { Controller } from "react-hook-form";

const RenderField = ({
  name,
  label,
  sideLabel,
  type,
  placeholder,
  required,
  values,
  multiline,
  rows,
  register,
  errors,
  max,
  min,
  minLength,
  maxLength,
  control,
  disabled,
}) => {
  const renderError = (name, errors) =>
    errors[name] && (
      <p role="alert" className={"text-danger"} style={{ fontSize: "12px" }}>
        {errors[name]?.message}
      </p>
    );

  const rules = {
    required: required
      ? typeof required === "string"
        ? required
        : "This field is required"
      : false,
    max:
      typeof max === "number"
        ? { value: max, message: `Maximum number is ${max?.toLocaleString()}` }
        : undefined,
    min:
      typeof min === "number"
        ? { value: min, message: `Minimum number is ${min?.toLocaleString()}` }
        : undefined,
    minLength:
      typeof minLength === "number"
        ? {
            value: minLength,
            message: `Minimum length is ${minLength?.toLocaleString()}`,
          }
        : undefined,
    maxLength:
      typeof maxLength === "number"
        ? {
            value: maxLength,
            message: `Maximum length is ${maxLength?.toLocaleString()}`,
          }
        : undefined,
    pattern:
      type === "tel"
        ? {
            value: /^(^\+?(?:[+0]9)?[0-9]{8,14}$)$/i,
            message: "Invalid Phone number",
          }
        : type === "email"
        ? {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          }
        : null,
  };

  const border = errors[name] ? "border-danger" : "border-b-0";
  const errorClass2 = errors[name]
    ? "select-error text-capitalize"
    : "text-capitalize border-0";
  const classN = `form-control ${border} `;
  const newLabel = (
    <Typography variant={"subtitle1"}>
      {label} {required ? <span className={"text-danger"}>*</span> : null}
    </Typography>
  );
  return (
    <FormGroup className={"mb-3"} key={name}>
      {(type === "file" || type==="select") && (
        <FormLabel className={"w-100"}>
          {sideLabel ? (
            <div className={"d-flex"}>
              <div className={"flex-grow-1"}>{newLabel}</div>
              {sideLabel}
            </div>
          ) : (
            newLabel
          )}
        </FormLabel>
      )}

      {type === "file" ? (
        <input className={classN} type={"file"} {...register(name, rules)} />
      ) : type === "react-select" || type === "country" ? (
        <Controller
        style={{ color: values === 0 ? "red" : "inherit" }}
          control={control}
          key={name}
          rules={rules}
          name={name}
          render={({ field, fieldState: { error } }) => {
            let selectedValue =
              values?.find((item) => item.value === field.value) ?? null;
            return type === "country" ? (
              <CountrySelector
                className={`${errorClass2}`}
                {...register(name, rules)}
                value={field.value}
                onChange={(v) => field.onChange(v?.value)}
              />
            ) : (
              <ReactSelect
                className={errorClass2}
                value={!field.value ? null : selectedValue}
                options={values}
                onChange={(v) => field.onChange(v?.value)}
              />
            );
          }}
        />
      ) : type === "select" ? (
        <select className={classN} {...register(name, rules)}>
          {values?.map((v) => (
            <option value={v.value}>{v.label}</option>
          ))}
        </select>
      ) : (
        <TextField
          label={label}
          variant="standard"
          required={required}
          sx={{
            "& .MuiInputLabel-standard": {
              color: "grey",
              fontWeight: "bold",
              fontSize: "15px",
            },
            // focus
            "& .MuiInputLabel-standard.Mui-focused": {
              color: "#C0C0C0",
              fontSize: "15px",
              fontWeight: "bold",
            },
            // style required icon
            "& .MuiInputLabel-asterisk": {
              // color: "#ff0000",
            },

            // border color
            "& .MuiInput-underline:before": {
              borderBottom: "1px solid grey",
            },

            // border color on focus
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid grey",
            },

            // border color on hover
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottom: "2px solid green",
            },

            // value color
            "& .MuiInputBase-input": {
              color: "black",
              fontSize: "18px",
              fontWeight: "normal", 
            },
          }}
          multiline={multiline}
          rows={rows}
          type={type}
          size={"small"}
          fullWidth={true}
          placeholder={placeholder ?? label}
          {...register(name, rules)}
          style={{ fontSize:"22px", fontWeight:"bold",  color: values === 0 ? "red" : "inherit" }}
        />
      )}
      {renderError(name, errors)}
    </FormGroup>
  );
};

export default RenderField;
